var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendWhats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    stroke: "#1756E8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6688 7.3252C17.1648 5.82656 15.1645 5.00088 13.0335 5C8.64233 5 5.06859 8.55654 5.06682 12.9278C5.06623 14.3252 5.43303 15.6893 6.13021 16.8916L5 21L9.22324 19.8975C10.3869 20.5292 11.697 20.8621 13.0302 20.8625H13.0336C17.4242 20.8625 20.9983 17.3057 21 12.9342C21.0009 10.8156 20.173 8.82373 18.6688 7.3252ZM13.0335 19.5235H13.0307C11.8426 19.523 10.6774 19.2053 9.66058 18.605L9.4189 18.4621L6.91277 19.1164L7.58169 16.6847L7.4242 16.4354C6.76136 15.3861 6.41134 14.1734 6.41193 12.9283C6.41331 9.29502 9.38377 6.33906 13.0361 6.33906C14.8047 6.33965 16.4673 7.02598 17.7174 8.27158C18.9675 9.51719 19.6556 11.1729 19.655 12.9337C19.6534 16.5673 16.6832 19.5235 13.0335 19.5235ZM16.6655 14.5881C16.4665 14.4889 15.4878 14.0098 15.3053 13.9436C15.123 13.8774 14.9901 13.8445 14.8575 14.0428C14.7248 14.241 14.3433 14.6873 14.2272 14.8194C14.111 14.9517 13.995 14.9683 13.7959 14.869C13.5968 14.7699 12.9555 14.5606 12.1951 13.8857C11.6034 13.3604 11.2039 12.7117 11.0877 12.5135C10.9717 12.315 11.0867 12.2182 11.1751 12.1092C11.3905 11.8429 11.6063 11.5637 11.6727 11.4315C11.7391 11.2993 11.7058 11.1836 11.656 11.0845C11.6063 10.9854 11.2082 10.0103 11.0424 9.61348C10.8807 9.22734 10.7167 9.27949 10.5944 9.27344C10.4785 9.26768 10.3457 9.2665 10.2129 9.2665C10.0803 9.2665 9.86459 9.31602 9.68207 9.51445C9.49966 9.71279 8.98548 10.192 8.98548 11.1671C8.98548 12.1422 9.69875 13.0842 9.79825 13.2164C9.89775 13.3486 11.2019 15.3496 13.1987 16.2076C13.6736 16.4119 14.0444 16.5337 14.3335 16.625C14.8104 16.7758 15.2442 16.7545 15.5873 16.7035C15.9698 16.6466 16.7649 16.2242 16.9309 15.7615C17.0968 15.2987 17.0968 14.9021 17.0469 14.8194C16.9973 14.7368 16.8645 14.6873 16.6655 14.5881Z",
    fill: "#1756E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWhats);
export default __webpack_public_path__ + "static/media/sendWhats.f50341c879d6d1069b196797f012067e.svg";
export { ForwardRef as ReactComponent };